import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { FormControl, FormControlLabel, Radio, RadioGroup, styled } from "@mui/material";
import Card from "../../components/Cards/Card";
import { useQlik } from "../../context/Qlik";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import { useHistory } from "react-router-dom";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

const LayoutCardWrapper = styled("div")({
  borderRadius: "16px",
  display: "flex",
  width: "100%",
  paddingRight: "10px",
});

function OpportunityDesktop({ app, config, filter }) {
  const { setSwitchOnDemand } = useQlik();

  const [alignment, setAlignment] = useState(filter);
  const [selectedYear, setSelectedYear] = useState("FY23");
  const { selections } = useSelections();
  const history = useHistory();

  const [selectedValue, setSelectedValue] = useState("Atingidos");

  function handleChangeValue (event) {
    app.field("Tipo_Cob").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Tipo_Cob")
        : null;
      setSelectedValue(distributors?.qSelected);
      
    }
  }, [app, selections]);

  useEffect(() => {
    if (selections.length) {
      const selection =
        selections.find((selection) => selection.qField === "Ano")
          ?.qSelected === "FY23" ?? false;
      if (selection && selectedYear === "FY24") {
        setSelectedYear("FY23");
        if (filter !== "Cobertura Qualificada") {
          history.push("/opportunity/coverage-5-of-6")
        }
      }
      if (!selection && selectedYear === "FY23") {
        if (filter !== "Cobertura Qualificada") {
          history.push("/opportunity/coverage-5-of-6");
        }
        setSelectedYear("FY24");
      }
    }
  }, [selections]);

  const tooltips = [
    {
      "Cobertura Qualificada": `Esse painel mostra os sku's do sortimento mínimo, referente a cobertura qualificada (${
        selectedYear === "FY23" ? "5" : "6"
      } de 6 sku's), onde podemos observar, por distribuidor e por pdv, a positivação de cada sku. O numero dentro de cada sku positivado, significa a quantidade que foi vendida daquele item.`,
      Inovação:
        "Esse painel mostra a cobertura de inovação, onde podemos observar, por distribuidor e por pdv, a positivação de cada sku. O numero dentro de cada sku positivado, significa a quantidade que foi vendida daquele item.",
      Oportunidades:
        "Esse painel mostra os sku's de oportunidade, onde podemos observar, por distribuidor e por pdv, a positivação de cada sku. O numero dentro de cada sku positivado, significa a quantidade que foi vendida daquele item.",
    },
    {
      "Cobertura Qualificada":
        "Esse gráfico mostra quantos pdv's foram positivados com determinada quantidade de sku's do sortimento mínimo. Na base do gráfico, temos a quantidade de Sku's e na parte superior da barra, temos a quantidade de pdv's, ou seja, xx número de pdv's, possuem x número  sku's positivados.",
      Inovação:
        "Esse gráfico mostra quantos pdv's foram positivados com determinada quantidade de sku's de inovação. Na base do gráfico, temos a quantidade de Sku's e na parte superior da barra, temos a quantidade de pdv's, ou seja, xx número de pdv's, possuem x número  sku's positivados.",
      Oportunidades:
        "Esse gráfico mostra quantos pdv's foram positivados com determinada quantidade de sku's de oportunidade. Na base do gráfico, temos a quantidade de Sku's e na parte superior da barra, temos a quantidade de pdv's, ou seja, xx número de pdv's, possuem x número  sku's positivados.",
    },
    {
      "Cobertura Qualificada": `Esse gráfico mostra quantos pdv's atingiram a cobertura qualificada (${
        selectedYear === "FY23" ? "5" : "6"
      } de 6 sku's do sortimento mínimo), por distribuidor.`,
      Inovação:
        "Esse gráfico mostra quantos pdv's atingiram a cobertura de inovação, por distribuidor.",
      Oportunidades:
        "Esse gráfico mostra quantos pdv's atingiram a cobertura com sku's de oportunidade, por distribuidor.",
    },
  ];

  const handleChange = async (newAlignment) => {
    await app
      .field("%Selecao_Prod")
      .selectMatch(
        newAlignment !== "Cobertura Qualificada"
          ? newAlignment
          : "Cobertura 5 de 6"
      );
    setAlignment(newAlignment);
  };

  useEffect(() => {
    handleChange(filter);
  }, [filter]);

  useEffect(() => {
    setSwitchOnDemand(false);
  }, []);

  return (
    <div className="app opportunity">
      <div className="appContent">
        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <div
              style={{
                display: "flex",
                width: "100%",
                padding: "0 8px",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h1
                style={{
                  marginLeft: "10px",
                }}
              >
                {alignment}
              </h1>
            </div>
          </LayoutCardWrapper>
          {/* KPIS */}
          <FormControl className="container-form-control" sx={{width: "100%"}}>
          <RadioGroup
            defaultValue={selectedValue}
            row
            name="row-radio-buttons-group"
            className="radio-group radio-group-button-export"
            value={selectedValue}
            onChange={handleChangeValue}
            sx={{ marginLeft: "20px" }}
          >
            <FormControlLabel
              value="Atingidos"
              sx={{
                color: "#212121",
              }}
              control={
                <Radio
                  size="small"
                  defaultChecked
                  sx={{
                    color: "#0190d2",
                    "&.Mui-checked": {
                      color: "#0190d2",
                    },
                  }}
                />
              }
              label="Atingidos"
            />

            <FormControlLabel
              value="Faltantes"
              sx={{
                color: "#212121",
              }}
              control={
                <Radio
                  size="small"
                  defaultChecked
                  sx={{
                    color: "#0190d2",
                    "&.Mui-checked": {
                      color: "#0190d2",
                    },
                  }}
                />
              }
              label="Faltantes"
            />
          </RadioGroup>
        </FormControl>
          <LayoutCardWrapper style={{ height: filter !== "Combos" ? "60%" : "92%"}}>
            <Card
              exportTable
              app={app}
              exportTableId={filter !== "Combos" ? "rvPpA" : "pMSvnhG"}
              header={{
                hardTitle: "Atingimento PDVs - " + alignment,
                tooltip: tooltips[0][alignment],
              }}
              style={{ width: "100%" }}
            >
              <NativeObject
                app={app}
                key={filter !== "Combos" ? "rvPpA" : "pMSvnhG"}
                reference={{ id: filter !== "Combos" ? "rvPpA" : "pMSvnhG" }}
                style={{ marginTop: "20px" }}
              />
            </Card>
          </LayoutCardWrapper>

          {/* KAPI E GRAFICO CENTRAL */}
          {filter !== "Combos" && (
            <LayoutCardWrapper style={{ height: "40%" }}>
              <Card
                header={{
                  hardTitle: "Quantidade de Positivações por SKU's",
                  tooltip: tooltips[1][alignment],
                }}
                style={{
                  width: "100%",
                }}
              >
                <NativeObject
                  app={app}
                  key="yrpwz"
                  reference={{ id: "yrpwz" }}
                  style={{ marginTop: "20px" }}
                />
              </Card>
              <Card
                header={{
                  hardTitle: " PDV's Positivados Por Distribuidor",
                  tooltip: tooltips[2][alignment],
                }}
                style={{
                  width: "100%",
                }}
              >
                <NativeObject
                  app={app}
                  key="Asbpr"
                  reference={{ id: "Asbpr" }}
                  style={{ marginTop: "20px" }}
                />
              </Card>
            </LayoutCardWrapper>
          )}
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

OpportunityDesktop.defaultProps = {
  app: null,
  config: {},
};

OpportunityDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OpportunityDesktop;
